import gql from "graphql-tag";

export const ADD_SERVICE_REQUEST_NOTE = gql`
  mutation AddServiceRequestNote(
    $serviceRequestId: ID!
    $note: String!
    $userName: String
    $isCustomerVisible: Boolean
  ) {
    addServiceRequestNote(
      serviceRequestId: $serviceRequestId
      note: $note
      userName: $userName
      isCustomerVisible: $isCustomerVisible
    ) {
      id
      notes {
        note
        createdBy
        createdByName
        createdAt
        isCustomerVisible
      }
    }
  }
`;










